// src/components/admin/AdminRoute.js
import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../common/Spinner";

// Same shape as PrivateRoute, but for userType === "admin" instead of "user".
// Kept separate rather than adding a role prop to PrivateRoute so the two
// don't end up with mismatched profile-completion logic tangled together —
// admins never go through the investor profile-completion flow.
const AdminRoute = () => {
  const auth = useSelector((s) => s.auth);
  const location = useLocation();

  const authChecked = !!auth.authChecked;
  const isAuthenticated = !!auth.isAuthenticated;
  const user = auth.user || {};

  // See authChecked in reducers/authReducer.js / PrivateRoute.js — gating
  // on `loading` here had the same "unmounts the current admin page every
  // time an unrelated thunk fires" problem as PrivateRoute did.
  if (!authChecked) return <Loader />;

  const isAdmin = isAuthenticated === true && user.userType === "admin";
  if (!isAdmin) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default AdminRoute;